// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"568a024c","515":"d16af4b6","544":"9f06a4ef","745":"2695206e","787":"1ed0c42c","854":"7aa1e1a7"}[chunkId] + ".chunk.js";
};